var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,4c8.4,0,15.79,5.41,19.85,15.24c0.2,0.49,0.2,1.04,0,1.53C35.79,30.59,28.4,36,20,36S4.21,30.59,0.15,20.76 c-0.2-0.49-0.2-1.04,0-1.53C4.21,9.41,11.6,4,20,4z M20,8C13.49,8,7.68,12.11,4.18,20c3.5,7.89,9.32,12,15.82,12 s12.32-4.11,15.82-12C32.32,12.11,26.51,8,20,8z M20,27.5c-4.14,0-7.5-3.36-7.5-7.5s3.36-7.5,7.5-7.5s7.5,3.36,7.5,7.5 S24.14,27.5,20,27.5z M20,23.5c1.93,0,3.5-1.57,3.5-3.5s-1.57-3.5-3.5-3.5s-3.5,1.57-3.5,3.5S18.07,23.5,20,23.5z"
  })));
};
export default SvgEye;